/* tslint:disable */
/* eslint-disable */
/**
 * WICSSend
 * API reference documentation for WICSSend
 *
 * The version of the OpenAPI document: 0.1.0-RC
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ApiLoginPost200Response } from '../model';
// @ts-ignore
import type { ApiLoginPost401Response } from '../model';
// @ts-ignore
import type { ApiLoginPostRequest } from '../model';
// @ts-ignore
import type { ApiTokenRefreshPostRequest } from '../model';
// @ts-ignore
import type { GetAppMeMe200Response } from '../model';
/**
 * SecurityApi - axios parameter creator
 * @export
 */
export const SecurityApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * This endpoint authenticates the user with a emailaddress and password
         * @summary Get a token by password and password
         * @param {ApiLoginPostRequest} apiLoginPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLoginPost: async (apiLoginPostRequest: ApiLoginPostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'apiLoginPostRequest' is not null or undefined
            assertParamExists('apiLoginPost', 'apiLoginPostRequest', apiLoginPostRequest)
            const localVarPath = `/api/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiLoginPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * THis endpoints takes a refresh token to generate a new `token` and return it with the still valid `refresh_token`.
         * @summary Get a new token by usage of the long living `refresh_token`.
         * @param {ApiTokenRefreshPostRequest} apiTokenRefreshPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTokenRefreshPost: async (apiTokenRefreshPostRequest: ApiTokenRefreshPostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'apiTokenRefreshPostRequest' is not null or undefined
            assertParamExists('apiTokenRefreshPost', 'apiTokenRefreshPostRequest', apiTokenRefreshPostRequest)
            const localVarPath = `/api/token/refresh`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiTokenRefreshPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppMeMe: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Token required
            await setApiKeyToObject(localVarHeaderParameter, "X-AUTH-TOKEN", configuration)

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SecurityApi - functional programming interface
 * @export
 */
export const SecurityApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SecurityApiAxiosParamCreator(configuration)
    return {
        /**
         * This endpoint authenticates the user with a emailaddress and password
         * @summary Get a token by password and password
         * @param {ApiLoginPostRequest} apiLoginPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLoginPost(apiLoginPostRequest: ApiLoginPostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiLoginPost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLoginPost(apiLoginPostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SecurityApi.apiLoginPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * THis endpoints takes a refresh token to generate a new `token` and return it with the still valid `refresh_token`.
         * @summary Get a new token by usage of the long living `refresh_token`.
         * @param {ApiTokenRefreshPostRequest} apiTokenRefreshPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTokenRefreshPost(apiTokenRefreshPostRequest: ApiTokenRefreshPostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiLoginPost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTokenRefreshPost(apiTokenRefreshPostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SecurityApi.apiTokenRefreshPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAppMeMe(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAppMeMe200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAppMeMe(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SecurityApi.getAppMeMe']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SecurityApi - factory interface
 * @export
 */
export const SecurityApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SecurityApiFp(configuration)
    return {
        /**
         * This endpoint authenticates the user with a emailaddress and password
         * @summary Get a token by password and password
         * @param {SecurityApiApiLoginPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLoginPost(requestParameters: SecurityApiApiLoginPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiLoginPost200Response> {
            return localVarFp.apiLoginPost(requestParameters.apiLoginPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * THis endpoints takes a refresh token to generate a new `token` and return it with the still valid `refresh_token`.
         * @summary Get a new token by usage of the long living `refresh_token`.
         * @param {SecurityApiApiTokenRefreshPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTokenRefreshPost(requestParameters: SecurityApiApiTokenRefreshPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiLoginPost200Response> {
            return localVarFp.apiTokenRefreshPost(requestParameters.apiTokenRefreshPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppMeMe(options?: RawAxiosRequestConfig): AxiosPromise<GetAppMeMe200Response> {
            return localVarFp.getAppMeMe(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiLoginPost operation in SecurityApi.
 * @export
 * @interface SecurityApiApiLoginPostRequest
 */
export interface SecurityApiApiLoginPostRequest {
    /**
     * 
     * @type {ApiLoginPostRequest}
     * @memberof SecurityApiApiLoginPost
     */
    readonly apiLoginPostRequest: ApiLoginPostRequest
}

/**
 * Request parameters for apiTokenRefreshPost operation in SecurityApi.
 * @export
 * @interface SecurityApiApiTokenRefreshPostRequest
 */
export interface SecurityApiApiTokenRefreshPostRequest {
    /**
     * 
     * @type {ApiTokenRefreshPostRequest}
     * @memberof SecurityApiApiTokenRefreshPost
     */
    readonly apiTokenRefreshPostRequest: ApiTokenRefreshPostRequest
}

/**
 * SecurityApi - object-oriented interface
 * @export
 * @class SecurityApi
 * @extends {BaseAPI}
 */
export class SecurityApi extends BaseAPI {
    /**
     * This endpoint authenticates the user with a emailaddress and password
     * @summary Get a token by password and password
     * @param {SecurityApiApiLoginPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecurityApi
     */
    public apiLoginPost(requestParameters: SecurityApiApiLoginPostRequest, options?: RawAxiosRequestConfig) {
        return SecurityApiFp(this.configuration).apiLoginPost(requestParameters.apiLoginPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * THis endpoints takes a refresh token to generate a new `token` and return it with the still valid `refresh_token`.
     * @summary Get a new token by usage of the long living `refresh_token`.
     * @param {SecurityApiApiTokenRefreshPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecurityApi
     */
    public apiTokenRefreshPost(requestParameters: SecurityApiApiTokenRefreshPostRequest, options?: RawAxiosRequestConfig) {
        return SecurityApiFp(this.configuration).apiTokenRefreshPost(requestParameters.apiTokenRefreshPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecurityApi
     */
    public getAppMeMe(options?: RawAxiosRequestConfig) {
        return SecurityApiFp(this.configuration).getAppMeMe(options).then((request) => request(this.axios, this.basePath));
    }
}

